import { lazy, ComponentType, LazyExoticComponent } from 'react'

const RELOAD_KEY = 'afo-chunk-reload'

/**
 * Loads a screen's code only when it is first opened. If that file is gone (the site was
 * redeployed while this tab was open, so the old file names no longer exist), reload once to
 * pick up the new version; if it still fails after one reload, surface the error normally.
 */
export const lazyPage = <T extends ComponentType<any>>(
	load: () => Promise<{ default: T }>
): LazyExoticComponent<T> =>
	lazy(async () => {
		try {
			const mod = await load()
			try { sessionStorage.removeItem(RELOAD_KEY) } catch { /* storage unavailable */ }
			return mod
		} catch (error) {
			let alreadyReloaded = true
			try {
				alreadyReloaded = sessionStorage.getItem(RELOAD_KEY) === '1'
				if (!alreadyReloaded) sessionStorage.setItem(RELOAD_KEY, '1')
			} catch { /* storage unavailable: do not loop */ }
			if (!alreadyReloaded) {
				window.location.reload()
				return new Promise<never>(() => {}) // page is going away
			}
			throw error
		}
	})
